import{styled as o}from"styled-components";const e=o.select`
  font:
    1em Verdana,
    Arial,
    sans-serif;
  width: ${({$width:o})=>o}px;
  border: 1px solid #a3a3a3;
  border-radius: 2px;
  margin: 1px 0px;
  outline: none;
  background: none;
`;export{e as YmSelect};
